// GENERATED CODE
// Manual modification is NOT RECOMMENDED as changes will be overwritten the next time the classes are generated.


/**
 * The Class Registry concept is designed to allow for users of the SHR ES6 classes to fix bugs and add extensions
 * in a way that makes maintaining those changes across re-generations easier.
 * Users should subclass any relevant classes, then update the class registry
 * (in a separate location, since the file is generated)
 * with a reference to the new class.
 * Note: this class structure is needed to avoid circular dependency issues,
 * as this refers to all the individual ES6 classes, and the individual ES6 classes all refer to this.
 */
class Registry {
  initialize() {
    this.internalRegistry = {
      'brca': {
        'BreastSite': require('./brca/BreastSite').default,
        'BreastSpecimen': require('./brca/BreastSpecimen').default,
        'ColdIschemiaTime': require('./brca/ColdIschemiaTime').default,
        'BreastCancerCondition': require('./brca/BreastCancerCondition').default,
        'BreastTNMPrognosticClinicalStageGroup': require('./brca/BreastTNMPrognosticClinicalStageGroup').default,
        'BreastTNMPathologicStageGroup': require('./brca/BreastTNMPathologicStageGroup').default,
        'BreastClinicalLymphNodeInvolvement': require('./brca/BreastClinicalLymphNodeInvolvement').default,
        'BreastLymphNodeBodyLocation': require('./brca/BreastLymphNodeBodyLocation').default,
        'LymphNodeMobility': require('./brca/LymphNodeMobility').default,
        'LymphNodeSize': require('./brca/LymphNodeSize').default,
        'BreastPathologicalLymphNodeInvolvement': require('./brca/BreastPathologicalLymphNodeInvolvement').default,
        'BreastLymphNodeInvolvement': require('./brca/BreastLymphNodeInvolvement').default,
        'LymphNodeSamplingMethod': require('./brca/LymphNodeSamplingMethod').default,
        'TotalNumberOfLymphNodesExamined': require('./brca/TotalNumberOfLymphNodesExamined').default,
        'NumberOfRegionalLymphNodes': require('./brca/NumberOfRegionalLymphNodes').default,
        'NumberOfSentinelLymphNodes': require('./brca/NumberOfSentinelLymphNodes').default,
        'NumberOfLymphNodesWithIsolatedTumorCells': require('./brca/NumberOfLymphNodesWithIsolatedTumorCells').default,
        'NumberOfLymphNodesWithMicrometastases': require('./brca/NumberOfLymphNodesWithMicrometastases').default,
        'NumberOfLymphNodesWithMacrometastases': require('./brca/NumberOfLymphNodesWithMacrometastases').default,
        'ExtraCapsularExtensionOfNodalTumorStatus': require('./brca/ExtraCapsularExtensionOfNodalTumorStatus').default,
        'HER2ReceptorStatus': require('./brca/HER2ReceptorStatus').default,
        'HER2byIHC': require('./brca/HER2byIHC').default,
        'CompleteMembraneStainingPercent': require('./brca/CompleteMembraneStainingPercent').default,
        'HER2byFISH': require('./brca/HER2byFISH').default,
        'AverageHER2SignalsPerCell': require('./brca/AverageHER2SignalsPerCell').default,
        'AverageCEP17SignalsPerCell': require('./brca/AverageCEP17SignalsPerCell').default,
        'HER2toCEP17Ratio': require('./brca/HER2toCEP17Ratio').default,
        'EstrogenReceptorStatus': require('./brca/EstrogenReceptorStatus').default,
        'EstrogenReceptorNuclearPositivity': require('./brca/EstrogenReceptorNuclearPositivity').default,
        'EstrogenReceptorAverageStainingIntensity': require('./brca/EstrogenReceptorAverageStainingIntensity').default,
        'ProgesteroneReceptorStatus': require('./brca/ProgesteroneReceptorStatus').default,
        'ProgesteroneReceptorNuclearPositivity': require('./brca/ProgesteroneReceptorNuclearPositivity').default,
        'ProgesteroneReceptorAverageStainingIntensity': require('./brca/ProgesteroneReceptorAverageStainingIntensity').default,
        'DCISNuclearGrade': require('./brca/DCISNuclearGrade').default,
        'BreastCancerHistologicGrade': require('./brca/BreastCancerHistologicGrade').default,
        'TubuleFormationScore': require('./brca/TubuleFormationScore').default,
        'NuclearPleomorphismScore': require('./brca/NuclearPleomorphismScore').default,
        'MitoticCountScore': require('./brca/MitoticCountScore').default,
        'OncotypeDxInvasiveRecurrenceScore': require('./brca/OncotypeDxInvasiveRecurrenceScore').default,
        'OncotypeDxDCISRecurrenceScore': require('./brca/OncotypeDxDCISRecurrenceScore').default,
        'ProsignaRecurrenceScore': require('./brca/ProsignaRecurrenceScore').default,
        'MammaprintRecurrenceScore': require('./brca/MammaprintRecurrenceScore').default,
      },
      'onco.core': {
        'CancerCondition': require('./onco/core/CancerCondition').default,
        'PrimaryCancerCondition': require('./onco/core/PrimaryCancerCondition').default,
        'HistologyMorphologyBehavior': require('./onco/core/HistologyMorphologyBehavior').default,
        'CancerStageGroup': require('./onco/core/CancerStageGroup').default,
        'TNMClinicalStageGroup': require('./onco/core/TNMClinicalStageGroup').default,
        'TNMPathologicStageGroup': require('./onco/core/TNMPathologicStageGroup').default,
        'TumorMarkerTest': require('./onco/core/TumorMarkerTest').default,
        'TumorMarkerTestDataValue': require('./onco/core/TumorMarkerTestDataValue').default,
        'CancerHistologicGrade': require('./onco/core/CancerHistologicGrade').default,
        'PractitionerInformationSource': require('./onco/core/PractitionerInformationSource').default,
        'SecondaryCancerCondition': require('./onco/core/SecondaryCancerCondition').default,
        'EvidenceType': require('./onco/core/EvidenceType').default,
        'CancerDiseaseStatus': require('./onco/core/CancerDiseaseStatus').default,
        'RelatedCancerCondition': require('./onco/core/RelatedCancerCondition').default,
        'Tumor': require('./onco/core/Tumor').default,
        'IsPrimaryTumor': require('./onco/core/IsPrimaryTumor').default,
        'TumorDimensions': require('./onco/core/TumorDimensions').default,
        'RelatedTumor': require('./onco/core/RelatedTumor').default,
        'TumorLongestDimension': require('./onco/core/TumorLongestDimension').default,
        'TumorDimension2': require('./onco/core/TumorDimension2').default,
        'TumorDimension3': require('./onco/core/TumorDimension3').default,
        'SizeOfGrossTumorBed': require('./onco/core/SizeOfGrossTumorBed').default,
        'TumorInvolvementAtSurgicalMargin': require('./onco/core/TumorInvolvementAtSurgicalMargin').default,
        'CancerRelatedSurgicalProcedure': require('./onco/core/CancerRelatedSurgicalProcedure').default,
        'CancerReasonReference': require('./onco/core/CancerReasonReference').default,
        'CancerRelatedRadiationProcedure': require('./onco/core/CancerRelatedRadiationProcedure').default,
        'GenomicsReport': require('./onco/core/GenomicsReport').default,
        'RegionStudied': require('./onco/core/RegionStudied').default,
        'GeneticMutationTestResult': require('./onco/core/GeneticMutationTestResult').default,
        'GeneStudied': require('./onco/core/GeneStudied').default,
        'MutationTested': require('./onco/core/MutationTested').default,
        'VariantIdentifier': require('./onco/core/VariantIdentifier').default,
        'VariantHGVSName': require('./onco/core/VariantHGVSName').default,
        'VariantDescription': require('./onco/core/VariantDescription').default,
        'GeneticVariantFound': require('./onco/core/GeneticVariantFound').default,
        'GenomicSourceClass': require('./onco/core/GenomicSourceClass').default,
        'VariantFoundIdentifier': require('./onco/core/VariantFoundIdentifier').default,
        'VariantFoundHGVSName': require('./onco/core/VariantFoundHGVSName').default,
        'VariantFoundDescription': require('./onco/core/VariantFoundDescription').default,
        'CancerStageCategory': require('./onco/core/CancerStageCategory').default,
        'TNMClinicalPrimaryTumorCategory': require('./onco/core/TNMClinicalPrimaryTumorCategory').default,
        'TNMClinicalRegionalNodesCategory': require('./onco/core/TNMClinicalRegionalNodesCategory').default,
        'TNMClinicalDistantMetastasesCategory': require('./onco/core/TNMClinicalDistantMetastasesCategory').default,
        'TNMPathologicPrimaryTumorCategory': require('./onco/core/TNMPathologicPrimaryTumorCategory').default,
        'TNMPathologicRegionalNodesCategory': require('./onco/core/TNMPathologicRegionalNodesCategory').default,
        'TNMPathologicDistantMetastasesCategory': require('./onco/core/TNMPathologicDistantMetastasesCategory').default,
        'CancerStagingSystem': require('./onco/core/CancerStagingSystem').default,
      },
      'shr.base': {
        'Entry': require('./shr/base/Entry').default,
        'ShrId': require('./shr/base/ShrId').default,
        'EntryId': require('./shr/base/EntryId').default,
        'EntryType': require('./shr/base/EntryType').default,
      },
      'shr.core': {
        'BodyLocation': require('./shr/core/BodyLocation').default,
        'LocationCode': require('./shr/core/LocationCode').default,
        'Quantity': require('./shr/core/Quantity').default,
        'Units': require('./shr/core/Units').default,
        'Resource': require('./shr/core/Resource').default,
        'DomainResource': require('./shr/core/DomainResource').default,
        'EntityOrRole': require('./shr/core/EntityOrRole').default,
        'Entity': require('./shr/core/Entity').default,
        'Status': require('./shr/core/Status').default,
        'PartOf': require('./shr/core/PartOf').default,
        'Specimen': require('./shr/core/Specimen').default,
        'SpecimenType': require('./shr/core/SpecimenType').default,
        'CollectionSite': require('./shr/core/CollectionSite').default,
        'CollectionMethod': require('./shr/core/CollectionMethod').default,
        'ClinicalStatement': require('./shr/core/ClinicalStatement').default,
        'SituationStatement': require('./shr/core/SituationStatement').default,
        'Code': require('./shr/core/Code').default,
        'Category': require('./shr/core/Category').default,
        'ClinicalStatus': require('./shr/core/ClinicalStatus').default,
        'Severity': require('./shr/core/Severity').default,
        'Condition': require('./shr/core/Condition').default,
        'StageInformation': require('./shr/core/StageInformation').default,
        'StageDetail': require('./shr/core/StageDetail').default,
        'Evidence': require('./shr/core/Evidence').default,
        'Manifestation': require('./shr/core/Manifestation').default,
        'CareContext': require('./shr/core/CareContext').default,
        'Observation': require('./shr/core/Observation').default,
        'NonLaboratoryObservation': require('./shr/core/NonLaboratoryObservation').default,
        'DataValue': require('./shr/core/DataValue').default,
        'CodedNonLaboratoryObservation': require('./shr/core/CodedNonLaboratoryObservation').default,
        'PanelMembers': require('./shr/core/PanelMembers').default,
        'ComponentOnlyNonLaboratoryObservation': require('./shr/core/ComponentOnlyNonLaboratoryObservation').default,
        'Method': require('./shr/core/Method').default,
        'Components': require('./shr/core/Components').default,
        'ObservationComponent': require('./shr/core/ObservationComponent').default,
        'CodedObservationComponent': require('./shr/core/CodedObservationComponent').default,
        'QuantitativeObservationComponent': require('./shr/core/QuantitativeObservationComponent').default,
        'LaboratoryObservation': require('./shr/core/LaboratoryObservation').default,
        'Interpretation': require('./shr/core/Interpretation').default,
        'CodedLaboratoryObservation': require('./shr/core/CodedLaboratoryObservation').default,
        'SimpleCodedLaboratoryObservation': require('./shr/core/SimpleCodedLaboratoryObservation').default,
        'SimpleLaboratoryObservation': require('./shr/core/SimpleLaboratoryObservation').default,
        'Questionnaire': require('./shr/core/Questionnaire').default,
        'Type': require('./shr/core/Type').default,
        'QuestionnaireItem': require('./shr/core/QuestionnaireItem').default,
        'Composition': require('./shr/core/Composition').default,
        'Section': require('./shr/core/Section').default,
        'SocialHistoryObservation': require('./shr/core/SocialHistoryObservation').default,
        'CodedSocialHistoryObservation': require('./shr/core/CodedSocialHistoryObservation').default,
        'SubjectOfInformationCode': require('./shr/core/SubjectOfInformationCode').default,
        'RelevantTime': require('./shr/core/RelevantTime').default,
        'Role': require('./shr/core/Role').default,
        'Person': require('./shr/core/Person').default,
        'RelatedPerson': require('./shr/core/RelatedPerson').default,
        'RelationshipToPatient': require('./shr/core/RelationshipToPatient').default,
        'PersonInformationSource': require('./shr/core/PersonInformationSource').default,
        'BodyStructure': require('./shr/core/BodyStructure').default,
        'ActionStatement': require('./shr/core/ActionStatement').default,
        'ActionPerformed': require('./shr/core/ActionPerformed').default,
        'Participation': require('./shr/core/Participation').default,
        'OnBehalfOf': require('./shr/core/OnBehalfOf').default,
        'RelatedRequest': require('./shr/core/RelatedRequest').default,
        'Procedure': require('./shr/core/Procedure').default,
        'SurgicalProcedure': require('./shr/core/SurgicalProcedure').default,
        'ReasonCode': require('./shr/core/ReasonCode').default,
        'ReasonReference': require('./shr/core/ReasonReference').default,
        'TerminationReason': require('./shr/core/TerminationReason').default,
        'RadiationProcedure': require('./shr/core/RadiationProcedure').default,
        'DiagnosticReport': require('./shr/core/DiagnosticReport').default,
        'SimpleCodedNonLaboratoryObservation': require('./shr/core/SimpleCodedNonLaboratoryObservation').default,
        'ParticipationType': require('./shr/core/ParticipationType').default,
        'ParticipationPeriod': require('./shr/core/ParticipationPeriod').default,
        'Outcome': require('./shr/core/Outcome').default,
        'ActionRequested': require('./shr/core/ActionRequested').default,
        'RequestIntent': require('./shr/core/RequestIntent').default,
        'ExpectedPerformanceTime': require('./shr/core/ExpectedPerformanceTime').default,
        'ExpectedPerformerType': require('./shr/core/ExpectedPerformerType').default,
        'Recipient': require('./shr/core/Recipient').default,
        'CommunicationMethod': require('./shr/core/CommunicationMethod').default,
        'Seriousness': require('./shr/core/Seriousness').default,
        'AdverseEvent': require('./shr/core/AdverseEvent').default,
        'SubjectOfRecord': require('./shr/core/SubjectOfRecord').default,
        'AdverseEventSubjectOfRecord': require('./shr/core/AdverseEventSubjectOfRecord').default,
        'AdverseEventRecorder': require('./shr/core/AdverseEventRecorder').default,
        'AdverseEventCondition': require('./shr/core/AdverseEventCondition').default,
        'CausalAttribution': require('./shr/core/CausalAttribution').default,
        'PossibleCause': require('./shr/core/PossibleCause').default,
        'CauseCategory': require('./shr/core/CauseCategory').default,
        'Certainty': require('./shr/core/Certainty').default,
        'ActionTaken': require('./shr/core/ActionTaken').default,
        'AssociatedStudy': require('./shr/core/AssociatedStudy').default,
        'AdverseDrugReaction': require('./shr/core/AdverseDrugReaction').default,
        'PossibleDrugCause': require('./shr/core/PossibleDrugCause').default,
        'AllergyIntolerance': require('./shr/core/AllergyIntolerance').default,
        'AllergyRecorder': require('./shr/core/AllergyRecorder').default,
        'SubstanceCategory': require('./shr/core/SubstanceCategory').default,
        'MostRecentOccurrenceTime': require('./shr/core/MostRecentOccurrenceTime').default,
        'AllergyIntoleranceReaction': require('./shr/core/AllergyIntoleranceReaction').default,
        'SubstanceCode': require('./shr/core/SubstanceCode').default,
        'ECOGPerformanceStatus': require('./shr/core/ECOGPerformanceStatus').default,
        'KarnofskyPerformanceStatus': require('./shr/core/KarnofskyPerformanceStatus').default,
        'Text': require('./shr/core/Text').default,
        'Number': require('./shr/core/Number').default,
        'Comparator': require('./shr/core/Comparator').default,
        'SimpleQuantity': require('./shr/core/SimpleQuantity').default,
        'IntegerQuantity': require('./shr/core/IntegerQuantity').default,
        'Age': require('./shr/core/Age').default,
        'Distance': require('./shr/core/Distance').default,
        'Duration': require('./shr/core/Duration').default,
        'Money': require('./shr/core/Money').default,
        'Coding': require('./shr/core/Coding').default,
        'CodeValue': require('./shr/core/CodeValue').default,
        'CodeSystem': require('./shr/core/CodeSystem').default,
        'CodeSystemVersion': require('./shr/core/CodeSystemVersion').default,
        'CodeableConcept': require('./shr/core/CodeableConcept').default,
        'Range': require('./shr/core/Range').default,
        'LowerBound': require('./shr/core/LowerBound').default,
        'UpperBound': require('./shr/core/UpperBound').default,
        'Ratio': require('./shr/core/Ratio').default,
        'Numerator': require('./shr/core/Numerator').default,
        'Denominator': require('./shr/core/Denominator').default,
        'Purpose': require('./shr/core/Purpose').default,
        'ContactPoint': require('./shr/core/ContactPoint').default,
        'TelecomNumberOrAddress': require('./shr/core/TelecomNumberOrAddress').default,
        'PriorityRank': require('./shr/core/PriorityRank').default,
        'PriorityRankUnsignedInt': require('./shr/core/PriorityRankUnsignedInt').default,
        'ContactDetail': require('./shr/core/ContactDetail').default,
        'TimePeriod': require('./shr/core/TimePeriod').default,
        'BeginDateTime': require('./shr/core/BeginDateTime').default,
        'EndDateTime': require('./shr/core/EndDateTime').default,
        'Timing': require('./shr/core/Timing').default,
        'TimingCode': require('./shr/core/TimingCode').default,
        'EventDuration': require('./shr/core/EventDuration').default,
        'RecurrencePattern': require('./shr/core/RecurrencePattern').default,
        'RecurrenceInterval': require('./shr/core/RecurrenceInterval').default,
        'DayOfWeek': require('./shr/core/DayOfWeek').default,
        'TimeOfDay': require('./shr/core/TimeOfDay').default,
        'DailyLifeEvent': require('./shr/core/DailyLifeEvent').default,
        'LifeEventOffset': require('./shr/core/LifeEventOffset').default,
        'CountPerInterval': require('./shr/core/CountPerInterval').default,
        'MinCount': require('./shr/core/MinCount').default,
        'MaxCount': require('./shr/core/MaxCount').default,
        'RecurrenceRange': require('./shr/core/RecurrenceRange').default,
        'NumberOfRepeats': require('./shr/core/NumberOfRepeats').default,
        'SampledData': require('./shr/core/SampledData').default,
        'DataAsString': require('./shr/core/DataAsString').default,
        'Origin': require('./shr/core/Origin').default,
        'MillisecondsBetweenSamples': require('./shr/core/MillisecondsBetweenSamples').default,
        'CorrectionFactor': require('./shr/core/CorrectionFactor').default,
        'LowerLimit': require('./shr/core/LowerLimit').default,
        'UpperLimit': require('./shr/core/UpperLimit').default,
        'Dimensions': require('./shr/core/Dimensions').default,
        'Address': require('./shr/core/Address').default,
        'AddressLine': require('./shr/core/AddressLine').default,
        'City': require('./shr/core/City').default,
        'District': require('./shr/core/District').default,
        'State': require('./shr/core/State').default,
        'PostalCode': require('./shr/core/PostalCode').default,
        'Country': require('./shr/core/Country').default,
        'Count': require('./shr/core/Count').default,
        'CommentOrDescription': require('./shr/core/CommentOrDescription').default,
        'DurationRange': require('./shr/core/DurationRange').default,
        'Statistic': require('./shr/core/Statistic').default,
        'StatisticType': require('./shr/core/StatisticType').default,
        'PriorityCode': require('./shr/core/PriorityCode').default,
        'Percentage': require('./shr/core/Percentage').default,
        'AgeGroup': require('./shr/core/AgeGroup').default,
        'GestationalAge': require('./shr/core/GestationalAge').default,
        'GestationalTimePeriod': require('./shr/core/GestationalTimePeriod').default,
        'Frequency': require('./shr/core/Frequency').default,
        'EffectiveTimePeriod': require('./shr/core/EffectiveTimePeriod').default,
        'ReceivedTime': require('./shr/core/ReceivedTime').default,
        'OccurrenceTimeOrPeriod': require('./shr/core/OccurrenceTimeOrPeriod').default,
        'NonOccurrenceTimeOrPeriod': require('./shr/core/NonOccurrenceTimeOrPeriod').default,
        'OccurrenceTime': require('./shr/core/OccurrenceTime').default,
        'OccurrencePeriod': require('./shr/core/OccurrencePeriod').default,
        'OccurrenceDuration': require('./shr/core/OccurrenceDuration').default,
        'Geoposition': require('./shr/core/Geoposition').default,
        'Latitude': require('./shr/core/Latitude').default,
        'Longitude': require('./shr/core/Longitude').default,
        'Altitude': require('./shr/core/Altitude').default,
        'Setting': require('./shr/core/Setting').default,
        'UnitedStatesAddress': require('./shr/core/UnitedStatesAddress').default,
        'UnitedStatesState': require('./shr/core/UnitedStatesState').default,
        'DisplayText': require('./shr/core/DisplayText').default,
        'VersionString': require('./shr/core/VersionString').default,
        'Title': require('./shr/core/Title').default,
        'EmbeddedContent': require('./shr/core/EmbeddedContent').default,
        'ParsableContent': require('./shr/core/ParsableContent').default,
        'Formalism': require('./shr/core/Formalism').default,
        'Attachment': require('./shr/core/Attachment').default,
        'BinaryData': require('./shr/core/BinaryData').default,
        'ContentType': require('./shr/core/ContentType').default,
        'ResourceLocation': require('./shr/core/ResourceLocation').default,
        'ResourceSize': require('./shr/core/ResourceSize').default,
        'Hash': require('./shr/core/Hash').default,
        'CreationDateTime': require('./shr/core/CreationDateTime').default,
        'PhotographicImage': require('./shr/core/PhotographicImage').default,
        'Annotation': require('./shr/core/Annotation').default,
        'AnnotationAuthor': require('./shr/core/AnnotationAuthor').default,
        'SignatureType': require('./shr/core/SignatureType').default,
        'Signature': require('./shr/core/Signature').default,
        'Signatory': require('./shr/core/Signatory').default,
        'RouteIntoBody': require('./shr/core/RouteIntoBody').default,
        'Laterality': require('./shr/core/Laterality').default,
        'Orientation': require('./shr/core/Orientation').default,
        'RelationToLandmark': require('./shr/core/RelationToLandmark').default,
        'LandmarkType': require('./shr/core/LandmarkType').default,
        'LandmarkLocation': require('./shr/core/LandmarkLocation').default,
        'LandmarkToBodyLocationDirection': require('./shr/core/LandmarkToBodyLocationDirection').default,
        'ClockFaceDirection': require('./shr/core/ClockFaceDirection').default,
        'AnatomicalDirection': require('./shr/core/AnatomicalDirection').default,
        'LandmarkToBodyLocationDistance': require('./shr/core/LandmarkToBodyLocationDistance').default,
        'Identifier': require('./shr/core/Identifier').default,
        'IdentifierString': require('./shr/core/IdentifierString').default,
        'Issuer': require('./shr/core/Issuer').default,
        'Name': require('./shr/core/Name').default,
        'NameAsText': require('./shr/core/NameAsText').default,
        'HumanName': require('./shr/core/HumanName').default,
        'Prefix': require('./shr/core/Prefix').default,
        'GivenName': require('./shr/core/GivenName').default,
        'MiddleName': require('./shr/core/MiddleName').default,
        'FamilyName': require('./shr/core/FamilyName').default,
        'Suffix': require('./shr/core/Suffix').default,
        'EncounterOrEpisode': require('./shr/core/EncounterOrEpisode').default,
        'Encounter': require('./shr/core/Encounter').default,
        'Participant': require('./shr/core/Participant').default,
        'EncounterParticipant': require('./shr/core/EncounterParticipant').default,
        'StatusHistory': require('./shr/core/StatusHistory').default,
        'EncounterClass': require('./shr/core/EncounterClass').default,
        'ClassHistory': require('./shr/core/ClassHistory').default,
        'EncounterDiagnosis': require('./shr/core/EncounterDiagnosis').default,
        'DiagnosisCode': require('./shr/core/DiagnosisCode').default,
        'EncounterLocation': require('./shr/core/EncounterLocation').default,
        'EpisodeOfCare': require('./shr/core/EpisodeOfCare').default,
        'CareManager': require('./shr/core/CareManager').default,
        'Replaces': require('./shr/core/Replaces').default,
        'ReferralRequest': require('./shr/core/ReferralRequest').default,
        'ReferralRequester': require('./shr/core/ReferralRequester').default,
        'ReferralRecipient': require('./shr/core/ReferralRecipient').default,
        'ServiceType': require('./shr/core/ServiceType').default,
        'RelatedInformation': require('./shr/core/RelatedInformation').default,
        'Appointment': require('./shr/core/Appointment').default,
        'ServiceCategory': require('./shr/core/ServiceCategory').default,
        'Specialty': require('./shr/core/Specialty').default,
        'Indication': require('./shr/core/Indication').default,
        'Need': require('./shr/core/Need').default,
        'AppointmentParticipation': require('./shr/core/AppointmentParticipation').default,
        'AppointmentParticipant': require('./shr/core/AppointmentParticipant').default,
        'Patient': require('./shr/core/Patient').default,
        'AccessTime': require('./shr/core/AccessTime').default,
        'Practitioner': require('./shr/core/Practitioner').default,
        'Affiliation': require('./shr/core/Affiliation').default,
        'NationalProviderIdentifier': require('./shr/core/NationalProviderIdentifier').default,
        'TaxIdentificationNumber': require('./shr/core/TaxIdentificationNumber').default,
        'Qualification': require('./shr/core/Qualification').default,
        'Group': require('./shr/core/Group').default,
        'Actual': require('./shr/core/Actual').default,
        'GroupCharacteristic': require('./shr/core/GroupCharacteristic').default,
        'GroupCharacteristicValue': require('./shr/core/GroupCharacteristicValue').default,
        'ExcludeFlag': require('./shr/core/ExcludeFlag').default,
        'MemberParticipation': require('./shr/core/MemberParticipation').default,
        'Member': require('./shr/core/Member').default,
        'InactiveFlag': require('./shr/core/InactiveFlag').default,
        'Mode': require('./shr/core/Mode').default,
        'Location': require('./shr/core/Location').default,
        'OperationalStatus': require('./shr/core/OperationalStatus').default,
        'Alias': require('./shr/core/Alias').default,
        'LocationName': require('./shr/core/LocationName').default,
        'PhysicalType': require('./shr/core/PhysicalType').default,
        'MobileFacility': require('./shr/core/MobileFacility').default,
        'ManagingOrganization': require('./shr/core/ManagingOrganization').default,
        'Substance': require('./shr/core/Substance').default,
        'Ingredient': require('./shr/core/Ingredient').default,
        'SubstanceOrCode': require('./shr/core/SubstanceOrCode').default,
        'IsActiveIngredient': require('./shr/core/IsActiveIngredient').default,
        'IngredientAmount': require('./shr/core/IngredientAmount').default,
        'Package': require('./shr/core/Package').default,
        'Medication': require('./shr/core/Medication').default,
        'DoseForm': require('./shr/core/DoseForm').default,
        'Brand': require('./shr/core/Brand').default,
        'IsBrand': require('./shr/core/IsBrand').default,
        'BrandName': require('./shr/core/BrandName').default,
        'OverTheCounter': require('./shr/core/OverTheCounter').default,
        'Manufacturer': require('./shr/core/Manufacturer').default,
        'LotNumber': require('./shr/core/LotNumber').default,
        'ExpirationDate': require('./shr/core/ExpirationDate').default,
        'PlaceOfBirth': require('./shr/core/PlaceOfBirth').default,
        'MultipleBirth': require('./shr/core/MultipleBirth').default,
        'BirthSex': require('./shr/core/BirthSex').default,
        'Race': require('./shr/core/Race').default,
        'RaceCode': require('./shr/core/RaceCode').default,
        'RaceDetail': require('./shr/core/RaceDetail').default,
        'Ethnicity': require('./shr/core/Ethnicity').default,
        'EthnicityCode': require('./shr/core/EthnicityCode').default,
        'EthnicityDetail': require('./shr/core/EthnicityDetail').default,
        'MothersMaidenName': require('./shr/core/MothersMaidenName').default,
        'FathersName': require('./shr/core/FathersName').default,
        'SocialSecurityNumber': require('./shr/core/SocialSecurityNumber').default,
        'DriversLicenseInformation': require('./shr/core/DriversLicenseInformation').default,
        'DriversLicenseNumber': require('./shr/core/DriversLicenseNumber').default,
        'StateOfIssue': require('./shr/core/StateOfIssue').default,
        'PassportInformation': require('./shr/core/PassportInformation').default,
        'PassportNumber': require('./shr/core/PassportNumber').default,
        'CountryOfIssue': require('./shr/core/CountryOfIssue').default,
        'MedicalInterpreter': require('./shr/core/MedicalInterpreter').default,
        'MedicalInterpreterNeeded': require('./shr/core/MedicalInterpreterNeeded').default,
        'MaritalStatus': require('./shr/core/MaritalStatus').default,
        'AnonymizedFlag': require('./shr/core/AnonymizedFlag').default,
        'FictionalPersonFlag': require('./shr/core/FictionalPersonFlag').default,
        'DateOfBirth': require('./shr/core/DateOfBirth').default,
        'AdministrativeGender': require('./shr/core/AdministrativeGender').default,
        'Communication': require('./shr/core/Communication').default,
        'Preferred': require('./shr/core/Preferred').default,
        'SpokenLanguageProficiency': require('./shr/core/SpokenLanguageProficiency').default,
        'WrittenLanguageProficiency': require('./shr/core/WrittenLanguageProficiency').default,
        'LanguageQualifier': require('./shr/core/LanguageQualifier').default,
        'Deceased': require('./shr/core/Deceased').default,
        'Organization': require('./shr/core/Organization').default,
        'OrganizationName': require('./shr/core/OrganizationName').default,
        'Device': require('./shr/core/Device').default,
        'DeviceUdi': require('./shr/core/DeviceUdi').default,
        'VendorModelNumber': require('./shr/core/VendorModelNumber').default,
        'ManufacturerName': require('./shr/core/ManufacturerName').default,
        'ManufactureDate': require('./shr/core/ManufactureDate').default,
        'Url': require('./shr/core/Url').default,
        'CollectionSource': require('./shr/core/CollectionSource').default,
        'CollectionTime': require('./shr/core/CollectionTime').default,
        'AccessionIdentifier': require('./shr/core/AccessionIdentifier').default,
        'HandlingRisk': require('./shr/core/HandlingRisk').default,
        'SpecialHandling': require('./shr/core/SpecialHandling').default,
        'SpecimenTreatment': require('./shr/core/SpecimenTreatment').default,
        'AmountOrSize': require('./shr/core/AmountOrSize').default,
        'SpecimenContainer': require('./shr/core/SpecimenContainer').default,
        'Capacity': require('./shr/core/Capacity').default,
        'SpecimenQuantity': require('./shr/core/SpecimenQuantity').default,
        'Additive': require('./shr/core/Additive').default,
        'SequenceNumber': require('./shr/core/SequenceNumber').default,
        'Media': require('./shr/core/Media').default,
        'MediaSubjectOfRecord': require('./shr/core/MediaSubjectOfRecord').default,
        'Subtype': require('./shr/core/Subtype').default,
        'View': require('./shr/core/View').default,
        'PixelHeight': require('./shr/core/PixelHeight').default,
        'PixelWidth': require('./shr/core/PixelWidth').default,
        'Frames': require('./shr/core/Frames').default,
        'NumberOfSecondsDuration': require('./shr/core/NumberOfSecondsDuration').default,
        'DataAbsentReason': require('./shr/core/DataAbsentReason').default,
        'ReferenceRange': require('./shr/core/ReferenceRange').default,
        'ApplicableSubpopulation': require('./shr/core/ApplicableSubpopulation').default,
        'ApplicableAgeRange': require('./shr/core/ApplicableAgeRange').default,
        'ObservationSubjectOfRecord': require('./shr/core/ObservationSubjectOfRecord').default,
        'Performer': require('./shr/core/Performer').default,
        'SimpleNonLaboratoryObservation': require('./shr/core/SimpleNonLaboratoryObservation').default,
        'QuantitativeNonLaboratoryObservation': require('./shr/core/QuantitativeNonLaboratoryObservation').default,
        'PlacerOrderNumber': require('./shr/core/PlacerOrderNumber').default,
        'FillerOrderNumber': require('./shr/core/FillerOrderNumber').default,
        'PractitionerOrOrganizationPerformer': require('./shr/core/PractitionerOrOrganizationPerformer').default,
        'PractitionerPerformer': require('./shr/core/PractitionerPerformer').default,
        'QuantitativeLaboratoryObservation': require('./shr/core/QuantitativeLaboratoryObservation').default,
        'SimpleQuantitativeLaboratoryObservation': require('./shr/core/SimpleQuantitativeLaboratoryObservation').default,
        'LaboratoryPanel': require('./shr/core/LaboratoryPanel').default,
        'HeadlessLaboratoryPanel': require('./shr/core/HeadlessLaboratoryPanel').default,
        'Panel': require('./shr/core/Panel').default,
        'HeadlessPanel': require('./shr/core/HeadlessPanel').default,
        'DateOfDiagnosis': require('./shr/core/DateOfDiagnosis').default,
        'ConditionCause': require('./shr/core/ConditionCause').default,
        'WhenClinicallyRecognized': require('./shr/core/WhenClinicallyRecognized').default,
        'Criticality': require('./shr/core/Criticality').default,
        'StageSummary': require('./shr/core/StageSummary').default,
        'AlleviatingFactor': require('./shr/core/AlleviatingFactor').default,
        'ExacerbatingFactor': require('./shr/core/ExacerbatingFactor').default,
        'Onset': require('./shr/core/Onset').default,
        'Abatement': require('./shr/core/Abatement').default,
        'ComorbidCondition': require('./shr/core/ComorbidCondition').default,
        'CongenitalAbnormality': require('./shr/core/CongenitalAbnormality').default,
        'DiagnosticReportParticipant': require('./shr/core/DiagnosticReportParticipant').default,
        'MedicationStatementRelatedRequest': require('./shr/core/MedicationStatementRelatedRequest').default,
        'Conclusion': require('./shr/core/Conclusion').default,
        'OriginalReport': require('./shr/core/OriginalReport').default,
        'DocumentStatus': require('./shr/core/DocumentStatus').default,
        'SecurityLabel': require('./shr/core/SecurityLabel').default,
        'DocumentReference': require('./shr/core/DocumentReference').default,
        'ClinicalNote': require('./shr/core/ClinicalNote').default,
        'Language': require('./shr/core/Language').default,
        'ImplicitRules': require('./shr/core/ImplicitRules').default,
        'Narrative': require('./shr/core/Narrative').default,
        'NarrativeText': require('./shr/core/NarrativeText').default,
        'NarrativeQualifier': require('./shr/core/NarrativeQualifier').default,
        'Metadata': require('./shr/core/Metadata').default,
        'VersionId': require('./shr/core/VersionId').default,
        'LastUpdated': require('./shr/core/LastUpdated').default,
        'Profile': require('./shr/core/Profile').default,
        'Tag': require('./shr/core/Tag').default,
        'StatementDateTime': require('./shr/core/StatementDateTime').default,
        'ValueSet': require('./shr/core/ValueSet').default,
        'IsExperimental': require('./shr/core/IsExperimental').default,
        'IsImmutable': require('./shr/core/IsImmutable').default,
        'IsExtensible': require('./shr/core/IsExtensible').default,
        'Jurisdiction': require('./shr/core/Jurisdiction').default,
        'UseContext': require('./shr/core/UseContext').default,
        'ContextValue': require('./shr/core/ContextValue').default,
        'SubjectType': require('./shr/core/SubjectType').default,
        'PublisherName': require('./shr/core/PublisherName').default,
        'DescriptionMarkdown': require('./shr/core/DescriptionMarkdown').default,
        'PurposeMarkdown': require('./shr/core/PurposeMarkdown').default,
        'Copyright': require('./shr/core/Copyright').default,
        'ContentLogicalDefinition': require('./shr/core/ContentLogicalDefinition').default,
        'LockedDate': require('./shr/core/LockedDate').default,
        'IncludeInactiveCodes': require('./shr/core/IncludeInactiveCodes').default,
        'IncludeCodes': require('./shr/core/IncludeCodes').default,
        'ExcludeCodes': require('./shr/core/ExcludeCodes').default,
        'CodeSet': require('./shr/core/CodeSet').default,
        'CodeSetConcept': require('./shr/core/CodeSetConcept').default,
        'Designation': require('./shr/core/Designation').default,
        'CodeSetFilter': require('./shr/core/CodeSetFilter').default,
        'Property': require('./shr/core/Property').default,
        'Operation': require('./shr/core/Operation').default,
        'ValueSetUri': require('./shr/core/ValueSetUri').default,
        'ValueSetExpansion': require('./shr/core/ValueSetExpansion').default,
        'TotalCount': require('./shr/core/TotalCount').default,
        'Offset': require('./shr/core/Offset').default,
        'ExpansionParameter': require('./shr/core/ExpansionParameter').default,
        'ParameterValue': require('./shr/core/ParameterValue').default,
        'ExpansionCoding': require('./shr/core/ExpansionCoding').default,
        'Inactive': require('./shr/core/Inactive').default,
        'NonSelectable': require('./shr/core/NonSelectable').default,
        'PatientSubjectOfRecord': require('./shr/core/PatientSubjectOfRecord').default,
        'MasterIdentifier': require('./shr/core/MasterIdentifier').default,
        'DocumentAuthor': require('./shr/core/DocumentAuthor').default,
        'Authenticator': require('./shr/core/Authenticator').default,
        'DocumentReferenced': require('./shr/core/DocumentReferenced').default,
        'Relationship': require('./shr/core/Relationship').default,
        'RelatedDocument': require('./shr/core/RelatedDocument').default,
        'ClinicalContext': require('./shr/core/ClinicalContext').default,
        'Event': require('./shr/core/Event').default,
        'FacilityType': require('./shr/core/FacilityType').default,
        'ContemporaneousPatientInformation': require('./shr/core/ContemporaneousPatientInformation').default,
        'AdditionalDosageInstruction': require('./shr/core/AdditionalDosageInstruction').default,
        'DosageMethod': require('./shr/core/DosageMethod').default,
        'Dosage': require('./shr/core/Dosage').default,
        'DoseAmount': require('./shr/core/DoseAmount').default,
        'TimingOfDoses': require('./shr/core/TimingOfDoses').default,
        'AsNeededIndicator': require('./shr/core/AsNeededIndicator').default,
        'DosageInstructionsText': require('./shr/core/DosageInstructionsText').default,
        'DosageBodyLocation': require('./shr/core/DosageBodyLocation').default,
        'MaximumDosePerTimePeriod': require('./shr/core/MaximumDosePerTimePeriod').default,
        'MedicationExposure': require('./shr/core/MedicationExposure').default,
        'MedicationCodeOrReference': require('./shr/core/MedicationCodeOrReference').default,
        'MedicationStatement': require('./shr/core/MedicationStatement').default,
        'MedicationStatementInformationSource': require('./shr/core/MedicationStatementInformationSource').default,
        'MedicationAdministration': require('./shr/core/MedicationAdministration').default,
        'PersonParticipant': require('./shr/core/PersonParticipant').default,
        'MedicationDispense': require('./shr/core/MedicationDispense').default,
        'SubstitutionReason': require('./shr/core/SubstitutionReason').default,
        'MedicationRequest': require('./shr/core/MedicationRequest').default,
        'MedicationRequester': require('./shr/core/MedicationRequester').default,
        'NumberOfRefillsAllowed': require('./shr/core/NumberOfRefillsAllowed').default,
        'QuantityPerDispense': require('./shr/core/QuantityPerDispense').default,
        'SupplyDuration': require('./shr/core/SupplyDuration').default,
        'SubstitutionAllowed': require('./shr/core/SubstitutionAllowed').default,
        'MedicationNonadherence': require('./shr/core/MedicationNonadherence').default,
        'MedicationNonAdherenceReason': require('./shr/core/MedicationNonAdherenceReason').default,
        'ProcedureParticipant': require('./shr/core/ProcedureParticipant').default,
        'MaterialUsed': require('./shr/core/MaterialUsed').default,
        'TreatmentIntent': require('./shr/core/TreatmentIntent').default,
        'FocalDevice': require('./shr/core/FocalDevice').default,
        'ProcedureRequest': require('./shr/core/ProcedureRequest').default,
        'ExpectedPerformer': require('./shr/core/ExpectedPerformer').default,
        'ProcedureRequester': require('./shr/core/ProcedureRequester').default,
        'ReferralSubjectOfRecord': require('./shr/core/ReferralSubjectOfRecord').default,
        'ImagingProcedure': require('./shr/core/ImagingProcedure').default,
        'ImagingSubstance': require('./shr/core/ImagingSubstance').default,
        'LaboratoryProcedure': require('./shr/core/LaboratoryProcedure').default,
        'SurgicalBodyLocation': require('./shr/core/SurgicalBodyLocation').default,
        'SurgicalBodyLocationRole': require('./shr/core/SurgicalBodyLocationRole').default,
        'PractitionerProcedureParticipant': require('./shr/core/PractitionerProcedureParticipant').default,
        'RadiationDosePerFraction': require('./shr/core/RadiationDosePerFraction').default,
        'RadiationFractionsDelivered': require('./shr/core/RadiationFractionsDelivered').default,
        'TotalRadiationDoseDelivered': require('./shr/core/TotalRadiationDoseDelivered').default,
        'DiagnosticImaging': require('./shr/core/DiagnosticImaging').default,
        'LastReviewedDate': require('./shr/core/LastReviewedDate').default,
        'ApprovalDate': require('./shr/core/ApprovalDate').default,
        'DetailsLink': require('./shr/core/DetailsLink').default,
        'Question': require('./shr/core/Question').default,
        'IsRequired': require('./shr/core/IsRequired').default,
        'MayRepeat': require('./shr/core/MayRepeat').default,
        'IsReadOnly': require('./shr/core/IsReadOnly').default,
        'MaxTextLength': require('./shr/core/MaxTextLength').default,
        'AnswerValueSet': require('./shr/core/AnswerValueSet').default,
        'AnswerOption': require('./shr/core/AnswerOption').default,
        'PrepopulateValue': require('./shr/core/PrepopulateValue').default,
        'EnableWhen': require('./shr/core/EnableWhen').default,
        'HasAnswer': require('./shr/core/HasAnswer').default,
        'AnswerValue': require('./shr/core/AnswerValue').default,
        'FocusOfResponse': require('./shr/core/FocusOfResponse').default,
        'QuestionnaireResponse': require('./shr/core/QuestionnaireResponse').default,
        'QuestionnaireResponseRecorder': require('./shr/core/QuestionnaireResponseRecorder').default,
        'QuestionnaireResponseItem': require('./shr/core/QuestionnaireResponseItem').default,
        'Answer': require('./shr/core/Answer').default,
        'ReferralOrProcedureRequest': require('./shr/core/ReferralOrProcedureRequest').default,
        'ObservationOrProcedure': require('./shr/core/ObservationOrProcedure').default,
        'ResearchStudy': require('./shr/core/ResearchStudy').default,
        'Enrollment': require('./shr/core/Enrollment').default,
        'Sponsor': require('./shr/core/Sponsor').default,
        'PrincipalInvestigator': require('./shr/core/PrincipalInvestigator').default,
        'StudyArm': require('./shr/core/StudyArm').default,
        'ResearchSubject': require('./shr/core/ResearchSubject').default,
        'VitalSignsPanel': require('./shr/core/VitalSignsPanel').default,
        'VitalSign': require('./shr/core/VitalSign').default,
        'Precondition': require('./shr/core/Precondition').default,
        'BodyWeight': require('./shr/core/BodyWeight').default,
        'BodyHeight': require('./shr/core/BodyHeight').default,
        'BodyPosition': require('./shr/core/BodyPosition').default,
        'BodyLength': require('./shr/core/BodyLength').default,
        'BloodPressure': require('./shr/core/BloodPressure').default,
        'SystolicPressure': require('./shr/core/SystolicPressure').default,
        'DiastolicPressure': require('./shr/core/DiastolicPressure').default,
        'BloodPressureCuffSize': require('./shr/core/BloodPressureCuffSize').default,
        'RespiratoryRate': require('./shr/core/RespiratoryRate').default,
        'HeartRate': require('./shr/core/HeartRate').default,
        'OxygenSaturation': require('./shr/core/OxygenSaturation').default,
        'SupplementalOxygenFlowrate': require('./shr/core/SupplementalOxygenFlowrate').default,
        'SupplementalOxygenConcentration': require('./shr/core/SupplementalOxygenConcentration').default,
        'BodyTemperature': require('./shr/core/BodyTemperature').default,
        'HeadCircumference': require('./shr/core/HeadCircumference').default,
        'BodyMassIndex': require('./shr/core/BodyMassIndex').default,
      },
      'shr.fhx': {
        'FamilyMember': require('./shr/fhx/FamilyMember').default,
        'FamilyMemberHistory': require('./shr/fhx/FamilyMemberHistory').default,
        'FamilyMemberCondition': require('./shr/fhx/FamilyMemberCondition').default,
        'ConditionOutcome': require('./shr/fhx/ConditionOutcome').default,
      },
      'shr.financial': {
        'CoverageType': require('./shr/financial/CoverageType').default,
        'Coverage': require('./shr/financial/Coverage').default,
        'Subscriber': require('./shr/financial/Subscriber').default,
        'SubscriberId': require('./shr/financial/SubscriberId').default,
        'Beneficiary': require('./shr/financial/Beneficiary').default,
        'PolicyHolder': require('./shr/financial/PolicyHolder').default,
      },
      'shr.lab': {
        'SimpleQuantLabWithRequiredUnits': require('./shr/lab/SimpleQuantLabWithRequiredUnits').default,
        'QuantityWithRequiredUnits': require('./shr/lab/QuantityWithRequiredUnits').default,
        'GlobulinMCncPtSerQnCalculatedLabObs': require('./shr/lab/GlobulinMCncPtSerQnCalculatedLabObs').default,
        'AlanineAminotransferaseCCncPtSerPlasQnLabObs': require('./shr/lab/AlanineAminotransferaseCCncPtSerPlasQnLabObs').default,
        'AlbuminMCncPtSerPlasQnLabObs': require('./shr/lab/AlbuminMCncPtSerPlasQnLabObs').default,
        'AlbuminGlobulinMRtoPtSerPlasQnLabObs': require('./shr/lab/AlbuminGlobulinMRtoPtSerPlasQnLabObs').default,
        'CalciumMCncPtSerPlasQnLabObs': require('./shr/lab/CalciumMCncPtSerPlasQnLabObs').default,
        'AspartateAminotransferaseCCncPtSerPlasQnLabObs': require('./shr/lab/AspartateAminotransferaseCCncPtSerPlasQnLabObs').default,
        'BilirubinMCncPtSerPlasQnLabObs': require('./shr/lab/BilirubinMCncPtSerPlasQnLabObs').default,
        'CarbonDioxideSCncPtSerPlasQnLabObs': require('./shr/lab/CarbonDioxideSCncPtSerPlasQnLabObs').default,
        'ChlorideSCncPtSerPlasQnLabObs': require('./shr/lab/ChlorideSCncPtSerPlasQnLabObs').default,
        'CreatinineMCncPtSerPlasQnLabObs': require('./shr/lab/CreatinineMCncPtSerPlasQnLabObs').default,
        'GlucoseMCncPtSerPlasQnLabObs': require('./shr/lab/GlucoseMCncPtSerPlasQnLabObs').default,
        'PotassiumSCncPtSerPlasQnLabObs': require('./shr/lab/PotassiumSCncPtSerPlasQnLabObs').default,
        'ProteinMCncPtSerPlasQnLabObs': require('./shr/lab/ProteinMCncPtSerPlasQnLabObs').default,
        'SodiumSCncPtSerPlasQnLabObs': require('./shr/lab/SodiumSCncPtSerPlasQnLabObs').default,
        'UreaNitrogenMCncPtSerPlasQnLabObs': require('./shr/lab/UreaNitrogenMCncPtSerPlasQnLabObs').default,
        'UreaNitrogenCreatinineMRtoPtSerPlasQnLabObs': require('./shr/lab/UreaNitrogenCreatinineMRtoPtSerPlasQnLabObs').default,
        'AlkalinePhosphataseCCncPtSerPlasQnLabObs': require('./shr/lab/AlkalinePhosphataseCCncPtSerPlasQnLabObs').default,
        'GFR173sqMPredArVRatPtSerPlasQnMDRDLabObs': require('./shr/lab/GFR173sqMPredArVRatPtSerPlasQnMDRDLabObs').default,
        'GFR173sqMPredFemaleArVRatPtSerPlasBldQnMDRDLabObs': require('./shr/lab/GFR173sqMPredFemaleArVRatPtSerPlasBldQnMDRDLabObs').default,
        'GFR173sqMPredNonBlackArVRatPtSerPlasBldQnMDRDLabObs': require('./shr/lab/GFR173sqMPredNonBlackArVRatPtSerPlasBldQnMDRDLabObs').default,
        'GFR173sqMPredBlackArVRatPtSerPlasBldQnMDRDLabObs': require('./shr/lab/GFR173sqMPredBlackArVRatPtSerPlasBldQnMDRDLabObs').default,
        'BilirubinDirectMCncPtSerPlasQnLabObs': require('./shr/lab/BilirubinDirectMCncPtSerPlasQnLabObs').default,
        'BicarbonateSCncPtSerPlasQnLabObs': require('./shr/lab/BicarbonateSCncPtSerPlasQnLabObs').default,
        'AniongapSCncPtSerPlasQnLabObs': require('./shr/lab/AniongapSCncPtSerPlasQnLabObs').default,
        'LeukocytesNCncPtBldQnAutoCntLabObs': require('./shr/lab/LeukocytesNCncPtBldQnAutoCntLabObs').default,
        'ErythrocytesNCncPtBldQnAutoCntLabObs': require('./shr/lab/ErythrocytesNCncPtBldQnAutoCntLabObs').default,
        'HemoglobinMCncPtBldQnLabObs': require('./shr/lab/HemoglobinMCncPtBldQnLabObs').default,
        'HematocritVFrPtBldQnAutoCntLabObs': require('./shr/lab/HematocritVFrPtBldQnAutoCntLabObs').default,
        'MeanCorpuscularVolumeEntVolPtRBCQnAutoCntLabObs': require('./shr/lab/MeanCorpuscularVolumeEntVolPtRBCQnAutoCntLabObs').default,
        'ErythrocyteMCHEntMassPtRBCQnAutoCntLabObs': require('./shr/lab/ErythrocyteMCHEntMassPtRBCQnAutoCntLabObs').default,
        'ErythrocyteMCHCMCncPtRBCQnAutoCntLabObs': require('./shr/lab/ErythrocyteMCHCMCncPtRBCQnAutoCntLabObs').default,
        'PlateletsNCncPtBldQnAutoCntLabObs': require('./shr/lab/PlateletsNCncPtBldQnAutoCntLabObs').default,
        'Neutrophils100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Neutrophils100WBCNFrPtBldQnAutoCntLabObs').default,
        'NeutrophilsNCncPtBldQnAutoCntLabObs': require('./shr/lab/NeutrophilsNCncPtBldQnAutoCntLabObs').default,
        'ErythrocyteDistributionWidthRatioPtRBCQnAutoCntLabObs': require('./shr/lab/ErythrocyteDistributionWidthRatioPtRBCQnAutoCntLabObs').default,
        'Lymphocytes100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Lymphocytes100WBCNFrPtBldQnAutoCntLabObs').default,
        'Monocytes100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Monocytes100WBCNFrPtBldQnAutoCntLabObs').default,
        'Eosinophils100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Eosinophils100WBCNFrPtBldQnAutoCntLabObs').default,
        'Basophils100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Basophils100WBCNFrPtBldQnAutoCntLabObs').default,
        'LymphocytesNCncPtBldQnAutoCntLabObs': require('./shr/lab/LymphocytesNCncPtBldQnAutoCntLabObs').default,
        'MonocytesNCncPtBldQnAutoCntLabObs': require('./shr/lab/MonocytesNCncPtBldQnAutoCntLabObs').default,
        'EosinophilsNCncPtBldQnAutoCntLabObs': require('./shr/lab/EosinophilsNCncPtBldQnAutoCntLabObs').default,
        'BasophilsNCncPtBldQnAutoCntLabObs': require('./shr/lab/BasophilsNCncPtBldQnAutoCntLabObs').default,
        'NeutrophilsBandForm100WBCNFrPtBldQnManCntLabObs': require('./shr/lab/NeutrophilsBandForm100WBCNFrPtBldQnManCntLabObs').default,
        'Metamyelocytes100WBCNFrPtBldQnManCntLabObs': require('./shr/lab/Metamyelocytes100WBCNFrPtBldQnManCntLabObs').default,
        'Myelocytes100WBCNFrPtBldQnManCntLabObs': require('./shr/lab/Myelocytes100WBCNFrPtBldQnManCntLabObs').default,
        'Promyelocytes100WBCNFrPtBldQnManCntLabObs': require('./shr/lab/Promyelocytes100WBCNFrPtBldQnManCntLabObs').default,
        'PromyelocytesNCncPtBldQnLabObs': require('./shr/lab/PromyelocytesNCncPtBldQnLabObs').default,
        'LymphocytesVariant100WBCNFrPtBldQnLabObs': require('./shr/lab/LymphocytesVariant100WBCNFrPtBldQnLabObs').default,
        'Blasts100WBCNFrPtBldQnManCntLabObs': require('./shr/lab/Blasts100WBCNFrPtBldQnManCntLabObs').default,
        'BlastsNCncPtBldQnLabObs': require('./shr/lab/BlastsNCncPtBldQnLabObs').default,
        'ErythrocytesNucleated100WBCRatioPtBldQnLabObs': require('./shr/lab/ErythrocytesNucleated100WBCRatioPtBldQnLabObs').default,
        'ErythrocytesNucleatedNCncPtBldQnLabObs': require('./shr/lab/ErythrocytesNucleatedNCncPtBldQnLabObs').default,
        'PlateletMeanVolumeEntVolPtBldQnReesEckerLabObs': require('./shr/lab/PlateletMeanVolumeEntVolPtBldQnReesEckerLabObs').default,
        'MyelocytesNCncPtBldQnLabObs': require('./shr/lab/MyelocytesNCncPtBldQnLabObs').default,
        'MetamyelocytesNCncPtBldQnLabObs': require('./shr/lab/MetamyelocytesNCncPtBldQnLabObs').default,
        'NeutrophilsBandFormNCncPtBldQnLabObs': require('./shr/lab/NeutrophilsBandFormNCncPtBldQnLabObs').default,
        'GranulocytesImmature100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/GranulocytesImmature100WBCNFrPtBldQnAutoCntLabObs').default,
        'GranulocytesImmatureNCncPtBldQnAutoCntLabObs': require('./shr/lab/GranulocytesImmatureNCncPtBldQnAutoCntLabObs').default,
        'ErythrocytesNucleated100WBCRatioPtBldQnAutoCntLabObs': require('./shr/lab/ErythrocytesNucleated100WBCRatioPtBldQnAutoCntLabObs').default,
        'MorphologyImpPtBldNarLabObs': require('./shr/lab/MorphologyImpPtBldNarLabObs').default,
        'ErythrocyteDistributionWidthEntVolPtRBCQnLabObs': require('./shr/lab/ErythrocyteDistributionWidthEntVolPtRBCQnLabObs').default,
        'PlateletDistributionWidthEntVolPtBldQnAutoCntLabObs': require('./shr/lab/PlateletDistributionWidthEntVolPtBldQnAutoCntLabObs').default,
        'PlateletMeanVolumeEntVolPtBldQnAutoCntLabObs': require('./shr/lab/PlateletMeanVolumeEntVolPtBldQnAutoCntLabObs').default,
        'NeutrophilsBandForm100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/NeutrophilsBandForm100WBCNFrPtBldQnAutoCntLabObs').default,
        'Granulocytes100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/Granulocytes100WBCNFrPtBldQnAutoCntLabObs').default,
        'LymphocytesVariant100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/LymphocytesVariant100WBCNFrPtBldQnAutoCntLabObs').default,
        'OtherCells100WBCNFrPtBldQnAutoCntLabObs': require('./shr/lab/OtherCells100WBCNFrPtBldQnAutoCntLabObs').default,
        'NeutrophilsBandFormNCncPtBldQnAutoCntLabObs': require('./shr/lab/NeutrophilsBandFormNCncPtBldQnAutoCntLabObs').default,
        'LymphocytesVariantNCncPtBldQnAutoCntLabObs': require('./shr/lab/LymphocytesVariantNCncPtBldQnAutoCntLabObs').default,
        'LeukocytesOtherNCncPtBldQnAutoCntLabObs': require('./shr/lab/LeukocytesOtherNCncPtBldQnAutoCntLabObs').default,
        'OtherCellsNCncPtBldQnAutoCntLabObs': require('./shr/lab/OtherCellsNCncPtBldQnAutoCntLabObs').default,
        'CBCWAutoDifferentialPanel': require('./shr/lab/CBCWAutoDifferentialPanel').default,
        'ComprehensiveMetabolic2000SerumOrPlasmaPanel': require('./shr/lab/ComprehensiveMetabolic2000SerumOrPlasmaPanel').default,
      },
      'shr.sdoh': {
        'HouseholdIncome': require('./shr/sdoh/HouseholdIncome').default,
        'IncomeSource': require('./shr/sdoh/IncomeSource').default,
        'NonCashBenefit': require('./shr/sdoh/NonCashBenefit').default,
        'FinancialStability': require('./shr/sdoh/FinancialStability').default,
        'IncomeAdequacy': require('./shr/sdoh/IncomeAdequacy').default,
        'TroubleAffordingFood': require('./shr/sdoh/TroubleAffordingFood').default,
        'TroubleAffordingHousing': require('./shr/sdoh/TroubleAffordingHousing').default,
        'TroubleAffordingUtilities': require('./shr/sdoh/TroubleAffordingUtilities').default,
        'TroubleAffordingTransportation': require('./shr/sdoh/TroubleAffordingTransportation').default,
        'TroubleAffordingMedication': require('./shr/sdoh/TroubleAffordingMedication').default,
        'TroubleAffordingDentalCare': require('./shr/sdoh/TroubleAffordingDentalCare').default,
        'TroubleAffordingChildCare': require('./shr/sdoh/TroubleAffordingChildCare').default,
        'HouseholdSize': require('./shr/sdoh/HouseholdSize').default,
        'Coinhabitant': require('./shr/sdoh/Coinhabitant').default,
        'NumberOfDependents': require('./shr/sdoh/NumberOfDependents').default,
        'TransportationAvailability': require('./shr/sdoh/TransportationAvailability').default,
        'HousingSecurity': require('./shr/sdoh/HousingSecurity').default,
        'PhysicalSafety': require('./shr/sdoh/PhysicalSafety').default,
        'EmotionalSafety': require('./shr/sdoh/EmotionalSafety').default,
        'DomesticViolence': require('./shr/sdoh/DomesticViolence').default,
        'HomeEnvironmentRisk': require('./shr/sdoh/HomeEnvironmentRisk').default,
        'EducationalAttainment': require('./shr/sdoh/EducationalAttainment').default,
        'ForeignCountryOfTravelTwoYears': require('./shr/sdoh/ForeignCountryOfTravelTwoYears').default,
        'UnprescribedExposure': require('./shr/sdoh/UnprescribedExposure').default,
        'SubstanceOrAgent': require('./shr/sdoh/SubstanceOrAgent').default,
        'ExposureMode': require('./shr/sdoh/ExposureMode').default,
        'ExposureAmount': require('./shr/sdoh/ExposureAmount').default,
        'ExposureReason': require('./shr/sdoh/ExposureReason').default,
        'ExposureRoute': require('./shr/sdoh/ExposureRoute').default,
        'AnimalExposure': require('./shr/sdoh/AnimalExposure').default,
        'PrenatalExposure': require('./shr/sdoh/PrenatalExposure').default,
        'SubstanceUse': require('./shr/sdoh/SubstanceUse').default,
        'IntravenousDrugUse': require('./shr/sdoh/IntravenousDrugUse').default,
        'NicotineExposure': require('./shr/sdoh/NicotineExposure').default,
        'TobaccoSmokingStatusNHIS': require('./shr/sdoh/TobaccoSmokingStatusNHIS').default,
        'AlcoholUse': require('./shr/sdoh/AlcoholUse').default,
        'AlcoholBingeEpisodes': require('./shr/sdoh/AlcoholBingeEpisodes').default,
      },
    };
  }

  /**
   * Get the class object for the given namespace and model class name.
   * I.e., the actual class is returned, not an instance of it.
   * In most cases this will be the original class,
   * but when a subclass has been defined and registered then it will be returned here.
   * @param {string} namespace - The full namespace of the desired class, ex. 'shr.base'.
   * @param {string} name - The name of the class, ex. 'Entry'
   * @return {Class} the desired class or a subclass of it with fixes/extensions
   */
  get(namespace, name) {
    return this.internalRegistry[namespace][name];
  }

  /**
   * Register a replacement class object for the given namespace and model class name.
   * Note that this does no validation that the given class is a true drop-in replacement of the original class
   * @param {string} namespace - The full namespace of the class, ex. 'shr.base'.
   * @param {string} name - The name of the class, ex. 'Entry'
   * @param {Class} klass - The new class object to be returned when 
   */
  set(namespace, name, klass) {
    this.internalRegistry[namespace][name] = klass;
  }
}

// singleton pattern
const ClassRegistry = new Registry();
export default ClassRegistry;
